import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RestaurantPage from "./RestaurantPage";
import AdminReservations from "./AdminReservations";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RestaurantPage />} />
          <Route path="/restaurant/baan-mae-r344153" element={<RestaurantPage />} />
          <Route path="/admin/reservations" element={<AdminReservations />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
